<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
              <PageHeader :title="title" :items="items"/>
                <b-card>
                    <div class="col-md-12" style="margin-bottom: 20px;">
                        <h4 class="text-center text-bold">Padma Bridge Rail Link Project (PBRLP)</h4>
                        <h5 class="text-center bold">
                          <span v-if="entitled_category_id == 1">AGL</span>
                          <span v-if="entitled_category_id == 2">AGWB</span>
                          <span v-if="entitled_category_id == 3">RRC</span>
                          <span v-if="entitled_category_id == 4">AGS</span>
                          <span v-if="entitled_category_id == 5">TG</span>
                          <span v-if="entitled_category_id == 6">RG</span>
                          <span v-if="entitled_category_id == 7">TG PCR/CPR</span>
                          <span v-if="entitled_category_id == 8">DRG PCR/CPR</span>
                          <span v-if="entitled_category_id == 9">AGT</span>
                          <span v-if="entitled_category_id == 10">CGVFT</span>
                          <span v-if="entitled_category_id == 11">CGSCFS</span>
                          <span v-if="entitled_category_id == 12">CGSLL</span>
                          <span v-if="entitled_category_id == 13">RVS</span>
                          <span v-if="entitled_category_id == 14">CGEE</span>
                          <span v-if="entitled_category_id == 15">RARO</span>
                          <span v-if="entitled_category_id == 16">RARI</span>
                          <span v-if="entitled_category_id == 17">MG</span>
                          <span v-if="entitled_category_id == 18">CGVMH</span>
                          <span v-if="entitled_category_id == 19">CGVFH</span>
                          <span v-if="entitled_category_id == 20">CGNUC</span>
                          <span v-if="entitled_category_id == 21">CGIDCIP</span>
                          <span v-if="entitled_category_id == 22">SGLIP</span>
                          <span v-if="entitled_category_id == 23">CGUAI</span>
                          <span v-if="entitled_category_id == 24">RV</span>
                        </h5>
                        <h5 class="text-center text-bold" style="margin-top:0px">Entitled Persons Benefits District Wise</h5>
                    </div>
                </b-card>


                <b-card>
                    <div  class="row mb-2">
                        <div class="col-sm-8">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ district_entitlements.length }}</span>
                        </div>
                    </div>
                    <div class="table-responsive scrollable-table" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>SL</th>
                                <th>District</th>
                                <th>No of EP</th>
                                <th>
                                  <span v-if="entitled_category_id == 1">Total AGL</span>
                                  <span v-if="entitled_category_id == 2">Total AGWB</span>
                                  <span v-if="entitled_category_id == 3">Total RRC</span>
                                  <span v-if="entitled_category_id == 4">Total AGS</span>
                                  <span v-if="entitled_category_id == 5">Total TG</span>
                                  <span v-if="entitled_category_id == 6">Total RG</span>
                                  <span v-if="entitled_category_id == 7">Total TG PCR/CPR</span>
                                  <span v-if="entitled_category_id == 8">Total DRG PCR/CPR</span>
                                  <span v-if="entitled_category_id == 9">Total AGT</span>
                                  <span v-if="entitled_category_id == 10">Total CGVFT</span>
                                  <span v-if="entitled_category_id == 11">Total CGSCFS</span>
                                  <span v-if="entitled_category_id == 12">Total CGSLL</span>
                                  <span v-if="entitled_category_id == 13">Total RVS</span>
                                  <span v-if="entitled_category_id == 14">Total CGEE</span>
                                  <span v-if="entitled_category_id == 15">Total RARO</span>
                                  <span v-if="entitled_category_id == 16">Total RARI</span>
                                  <span v-if="entitled_category_id == 17">Total MG</span>
                                  <span v-if="entitled_category_id == 18">Total CGVMH</span>
                                  <span v-if="entitled_category_id == 19">Total CGVFH</span>
                                  <span v-if="entitled_category_id == 20">Total CGNUC</span>
                                  <span v-if="entitled_category_id == 21">Total CGIDCIP</span>
                                  <span v-if="entitled_category_id == 22">Total SGLIP</span>
                                  <span v-if="entitled_category_id == 23">Total CGUAI</span>
                                  <span v-if="entitled_category_id == 24">Total RV</span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(district_entitlement, index) in district_entitlements" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ district_entitlement.district_desc }}</td>
                                <td>{{ district_entitlement.total_eps }}</td>
                                <td>
                                  <span v-if="entitled_category_id == 1"> {{ district_entitlement.total_AGL }} </span>
                                  <span v-if="entitled_category_id == 2"> {{ district_entitlement.total_AGWB }} </span>
                                  <span v-if="entitled_category_id == 3"> {{ district_entitlement.total_RRC }} </span>
                                  <span v-if="entitled_category_id == 4"> {{ district_entitlement.total_AGS }} </span>
                                  <span v-if="entitled_category_id == 5"> {{ district_entitlement.total_TG }} </span>
                                  <span v-if="entitled_category_id == 6"> {{ district_entitlement.total_RG }} </span>
                                  <span v-if="entitled_category_id == 7"> {{ district_entitlement.total_TG_PCR_CPR }} </span>
                                  <span v-if="entitled_category_id == 8"> {{ district_entitlement.total_DRG_PCR_CPR }} </span>
                                  <span v-if="entitled_category_id == 9"> {{ district_entitlement.total_AGT }} </span>
                                  <span v-if="entitled_category_id == 10"> {{ district_entitlement.total_CGVFT }} </span>
                                  <span v-if="entitled_category_id == 11"> {{ district_entitlement.total_CGSCFS }} </span>
                                  <span v-if="entitled_category_id == 12"> {{ district_entitlement.total_CGSLL }} </span>
                                  <span v-if="entitled_category_id == 13"> {{ district_entitlement.total_RVS }} </span>
                                  <span v-if="entitled_category_id == 14"> {{ district_entitlement.total_CGEE }} </span>
                                  <span v-if="entitled_category_id == 15"> {{ district_entitlement.total_RARO }} </span>
                                  <span v-if="entitled_category_id == 16"> {{ district_entitlement.total_RARI }} </span>
                                  <span v-if="entitled_category_id == 17"> {{ district_entitlement.total_MG }} </span>
                                  <span v-if="entitled_category_id == 18"> {{ district_entitlement.total_CGVMH }} </span>
                                  <span v-if="entitled_category_id == 19"> {{ district_entitlement.total_CGVFH }} </span>
                                  <span v-if="entitled_category_id == 20"> {{ district_entitlement.total_CGNUC }} </span>
                                  <span v-if="entitled_category_id == 21"> {{ district_entitlement.total_CGIDCIP }} </span>
                                  <span v-if="entitled_category_id == 22"> {{ district_entitlement.total_CGLIP }} </span>
                                  <span v-if="entitled_category_id == 23"> {{ district_entitlement.total_CGUAI }} </span>
                                  <span v-if="entitled_category_id == 24"> {{ district_entitlement.total_RV }} </span>
                                </td>
                            </tr>
                            </tbody>
                          <tfoot v-if="district_entitlements.length > 0">
                          <tr>
                            <td></td>
                            <td><span style="font-size:14px;"><b>Total</b></span></td>
                            <td>{{ total_entitlement_category.total_eps }}</td>
                            <td>
                              <span v-if="entitled_category_id == 1"> {{ total_entitlement_category.total_AGL }} </span>
                              <span v-if="entitled_category_id == 2"> {{ total_entitlement_category.total_AGWB }} </span>
                              <span v-if="entitled_category_id == 3"> {{ total_entitlement_category.total_RRC }} </span>
                              <span v-if="entitled_category_id == 4"> {{ total_entitlement_category.total_AGS }} </span>
                              <span v-if="entitled_category_id == 5"> {{ total_entitlement_category.total_TG }} </span>
                              <span v-if="entitled_category_id == 6"> {{ total_entitlement_category.total_RG }} </span>
                              <span v-if="entitled_category_id == 7"> {{ total_entitlement_category.total_TG_PCR_CPR }} </span>
                              <span v-if="entitled_category_id == 8"> {{ total_entitlement_category.total_DRG_PCR_CPR }} </span>
                              <span v-if="entitled_category_id == 9"> {{ total_entitlement_category.total_AGT }} </span>
                              <span v-if="entitled_category_id == 10"> {{ total_entitlement_category.total_CGVFT }} </span>
                              <span v-if="entitled_category_id == 11"> {{ total_entitlement_category.total_CGSCFS }} </span>
                              <span v-if="entitled_category_id == 12"> {{ total_entitlement_category.total_CGSLL }} </span>
                              <span v-if="entitled_category_id == 13"> {{ total_entitlement_category.total_RVS }} </span>
                              <span v-if="entitled_category_id == 14"> {{ total_entitlement_category.total_CGEE }} </span>
                              <span v-if="entitled_category_id == 15"> {{ total_entitlement_category.total_RARO }} </span>
                              <span v-if="entitled_category_id == 16"> {{ total_entitlement_category.total_RARI }} </span>
                              <span v-if="entitled_category_id == 17"> {{ total_entitlement_category.total_MG }} </span>
                              <span v-if="entitled_category_id == 18"> {{ total_entitlement_category.total_CGVMH }} </span>
                              <span v-if="entitled_category_id == 19"> {{ total_entitlement_category.total_CGVFH }} </span>
                              <span v-if="entitled_category_id == 20"> {{ total_entitlement_category.total_CGNUC }} </span>
                              <span v-if="entitled_category_id == 21"> {{ total_entitlement_category.total_CGIDCIP }} </span>
                              <span v-if="entitled_category_id == 22"> {{ total_entitlement_category.total_CGLIP }} </span>
                              <span v-if="entitled_category_id == 23"> {{ total_entitlement_category.total_CGUAI }} </span>
                              <span v-if="entitled_category_id == 24"> {{ total_entitlement_category.total_RV }} </span>
                            </td>
                          </tr>
                          </tfoot>
                        </table>
                       <div v-if="loader" class="loader">Loading...</div>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config.json";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Entitled Persons Benefits District Wise",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Entitled Persons Benefits District Wise",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Entitled",
                        active: true
                    }
                ],
                district_entitlements: [],
                entitled_category_id: '',
                total_entitlement_category: {},
                flag: false,
                loader: false
            };
        },


        mounted() {
            this.entitled_category_id = this.$route.params.entitled_category_id;
            this.getDistrictEntitlement();
        },
        methods: {
            getDistrictEntitlement() {
                this.loader = true
                let entitled_category_id = this.$route.params.entitled_category_id;
                http.get("api/payment/entitlement/district/list/" + entitled_category_id).then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.loader = false
                        this.district_entitlements = data.district_entitlements;
                        this.total_entitlement_category = data.total_entitlement_category;
                    }
                });
            },
        },
    };
</script>
<style>
    .scrollable-table {
        overflow-x: auto;
        white-space: nowrap;
    }
</style>
